(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dev-color-sibling-swatches"] && !Shopify.designMode) return;
  try {
    (function () {
    'use strict';

    /** @type {WeakMap<Element, {src: string, srcset: string}>} */
    const galleryState = new WeakMap();
    /** @type {WeakSet<Element>} */
    const warmedWraps = new WeakSet();
    /** @type {Set<string>} */
    const warmedUrls = new Set();

    const canHoverPreview =
      typeof window.matchMedia === 'function' && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    /**
     * Returns the first visible product image within a media-gallery element.
     * Handles both carousel (slideshow) and grid presentation modes.
     * @param {HTMLElement} gallery
     * @returns {HTMLImageElement | null}
     */
    function findFirstGalleryImage(gallery) {
      if (gallery.dataset.presentation === 'grid') {
        const img = gallery.querySelector('.media-gallery__grid li:first-child img');
        if (img) return img;
      }
      return (
        gallery.querySelector('slideshow-slide[aria-hidden="false"] img') ||
        gallery.querySelector('slideshow-slide img')
      );
    }

    /**
     * Warm a sibling packshot URL into the browser HTTP cache.
     * @param {string | undefined} url
     */
    function warmUrl(url) {
      if (!url || warmedUrls.has(url)) return;
      warmedUrls.add(url);
      const image = new Image();
      image.decoding = 'async';
      image.src = url;
    }

    /**
     * Preload hover packshots for a PDP / quick-add swatch row (once). Skips product cards.
     * @param {Element} wrap
     */
    function warmWrapHoverImages(wrap) {
      if (!canHoverPreview || warmedWraps.has(wrap)) return;
      if (wrap.closest('product-card')) return;
      warmedWraps.add(wrap);

      const swatches = wrap.querySelectorAll('[data-hover-image]');
      for (const swatch of swatches) {
        if (!(swatch instanceof HTMLElement)) continue;
        warmUrl(swatch.dataset.hoverImage);
      }
    }

    /**
     * Resolve the non-card swatch wrap for warming from an event target.
     * @param {Element} target
     * @returns {Element | null}
     */
    function findPdpSwatchWrap(target) {
      if (target.closest('product-card')) return null;
      return target.closest('[data-dev-color-sibling-swatches]') || target.closest('[data-name="color-swatches"]');
    }

    // Pre-save the original gallery state so the restore always reflects the
    // pristine initial image. Runs immediately if the DOM is already parsed
    // (module scripts can execute after DOMContentLoaded), or waits for the
    // event otherwise.
    function preSaveGalleryState() {
      document.querySelectorAll('.shopify-section media-gallery').forEach((gallery) => {
        const img = findFirstGalleryImage(gallery);
        if (img) galleryState.set(gallery, { src: img.src, srcset: img.srcset });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', preSaveGalleryState);
    } else {
      preSaveGalleryState();
    }

    // Capture: pointerenter does not bubble; warm as soon as the cursor enters the swatch row.
    document.addEventListener(
      'pointerenter',
      (e) => {
        if (!(e.target instanceof Element)) return;
        const wrap = findPdpSwatchWrap(e.target);
        if (!wrap) return;
        warmWrapHoverImages(wrap);
      },
      true
    );

    document.addEventListener('mouseover', (e) => {
      const swatch = e.target.closest('.cs-color[data-color-label]');
      if (!swatch) return;
      if (swatch.closest('product-card')) return;

      const wrap = findPdpSwatchWrap(swatch);
      if (wrap) warmWrapHoverImages(wrap);

      const section = swatch.closest('.shopify-section');
      if (!section) return;

      // Preview sibling color name — use Weglot-translated swatch text, stash current for leave.
      const nameEl = section.querySelector('[data-dev-pdp-color-name]');
      if (nameEl) {
        if (!nameEl.hasAttribute('data-color-label-restore')) {
          nameEl.setAttribute('data-color-label-restore', nameEl.textContent || '');
        }
        const labelEl = swatch.querySelector('.cs-swatch-label');
        const next =
          (labelEl?.textContent || '').trim() ||
          (swatch.getAttribute('aria-label') || '').trim() ||
          swatch.dataset.colorLabel ||
          '';
        if (next) nameEl.textContent = next;
      }

      const gallery = section.querySelector('media-gallery');
      if (!gallery) return;

      const img = findFirstGalleryImage(gallery);
      if (!img) return;

      if (!swatch.dataset.hoverImage) {
        // Active swatch — restore original image if something was previously swapped
        if (galleryState.has(gallery)) {
          const state = galleryState.get(gallery);
          if (state) {
            img.src = state.src;
            img.srcset = state.srcset;
          }
        }
        return;
      }

      if (!galleryState.has(gallery)) {
        galleryState.set(gallery, { src: img.src, srcset: img.srcset });
      }

      img.src = swatch.dataset.hoverImage;
      img.srcset = '';
    });

    document.addEventListener('mouseout', (e) => {
      const wrap = e.target.closest('[data-name="color-swatches"]');
      if (!wrap) return;
      if (wrap.contains(e.relatedTarget)) return;
      if (wrap.closest('product-card')) return;

      const section = wrap.closest('.shopify-section');
      if (!section) return;

      // Restore the pre-hover label (already Weglot-translated textContent).
      const nameEl = section.querySelector('[data-dev-pdp-color-name]');
      if (nameEl?.hasAttribute('data-color-label-restore')) {
        nameEl.textContent = nameEl.getAttribute('data-color-label-restore') || '';
        nameEl.removeAttribute('data-color-label-restore');
      }

      // Restore gallery image
      const gallery = section.querySelector('media-gallery');
      if (!gallery) return;

      if (!galleryState.has(gallery)) return;

      const state = galleryState.get(gallery);
      if (!state) return;

      const img = findFirstGalleryImage(gallery);
      if (img) {
        img.src = state.src;
        img.srcset = state.srcset;
      }

      galleryState.delete(gallery);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dev-gallery-breadcrumbs"] && !Shopify.designMode) return;
  try {
    (() => {
    const MOBILE_NAV = '[data-gallery-breadcrumbs]:not(.nooma-gallery-breadcrumbs--desktop)';

    const fit = (nav) => {
      if (nav.clientWidth === 0) return;

      const list = nav.querySelector('[data-gallery-breadcrumbs-list]');
      const ellipsis = nav.querySelector('[data-gallery-breadcrumbs-ellipsis]');
      if (!list || !ellipsis) return;

      const items = [...nav.querySelectorAll('[data-gallery-breadcrumbs-item]')];
      ellipsis.hidden = true;
      for (const item of items) item.hidden = false;

      if (items.length > 2 && list.scrollWidth > list.clientWidth + 1) {
        /* Overflow → ellipsis + last two only (do not keep a third that crowds the wishlist). */
        ellipsis.hidden = false;
        for (let i = 0; i < items.length - 2; i++) {
          items[i].hidden = true;
        }
      }

      nav.setAttribute('data-gallery-breadcrumbs-ready', '');
    };

    const init = () => {
      const navs = document.querySelectorAll(MOBILE_NAV);
      if (!navs.length) return;

      const observer = new ResizeObserver((entries) => {
        for (const entry of entries) fit(entry.target);
      });

      for (const nav of navs) {
        observer.observe(nav);
        fit(nav);
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["dev-product-gallery-dynamic"] && !Shopify.designMode) return;
  try {
    class NoomaShowMore extends HTMLElement {
    connectedCallback() {
      if (window.innerWidth < 750) return;

      const wrapper = this.closest('.nooma-gallery__reveal-wrapper');
      const clip = wrapper?.querySelector('.nooma-gallery__grid-clip');
      const grid = clip?.querySelector('.media-gallery__grid');
      const btn = this.querySelector('[data-show-more-btn]');
      if (!wrapper || !clip || !grid || !btn) return;

      this._wrapper = wrapper;
      this._clip = clip;
      this._grid = grid;
      this._btn = btn;
      this._previewRows = parseInt(this.dataset.previewRows, 10) || 2;
      this._expanded = false;

      // Lock width to the longer label so Safari sticky does not leave a ghost
      // border when swapping "View more images (N)" ↔ "Collapse images (N)".
      this._lockMinWidth();

      const update = () => {
        if (this._expanded) return;
        const h = this._calcPreviewHeight();
        if (h === null) {
          this._clip.style.maxHeight = '';
          this.hidden = true;
        } else {
          this._clip.style.maxHeight = h + 'px';
          this.hidden = false;
        }
      };

      const ro = new ResizeObserver(update);
      ro.observe(grid);
      this._ro = ro;
      update();

      btn.addEventListener('click', () => {
        this._expanded ? this._collapse() : this._expand();
      });
    }

    _lockMinWidth() {
      const btn = this._btn;
      const labelNodes = btn.querySelectorAll('[data-button-label]');
      const current = labelNodes.length ? labelNodes[0].textContent : btn.textContent;

      this._setLabel(this.dataset.labelMore || current);
      const wMore = btn.offsetWidth;
      this._setLabel(this.dataset.labelLess || current);
      const wLess = btn.offsetWidth;
      this._setLabel(current);
      btn.style.minWidth = `${Math.max(wMore, wLess)}px`;
    }

    // Returns pixel height from clip top to bottom of the Nth grid row,
    // or null if the grid has N or fewer rows (nothing to clip).
    _calcPreviewHeight() {
      const items = Array.from(this._grid.querySelectorAll(':scope > li'));
      if (!items.length) return null;

      const clipTop = this._clip.getBoundingClientRect().top;

      const rowMap = new Map();
      for (const li of items) {
        const top = Math.round(li.getBoundingClientRect().top);
        if (!rowMap.has(top)) rowMap.set(top, []);
        rowMap.get(top).push(li);
      }

      const sortedTops = [...rowMap.keys()].sort((a, b) => a - b);
      if (sortedTops.length <= this._previewRows) return null;

      const nthRowTop = sortedTops[this._previewRows - 1];
      const lastItem = rowMap.get(nthRowTop).at(-1);
      return Math.round(lastItem.getBoundingClientRect().bottom - clipTop);
    }

    _expand() {
      const scrollTop = this._firstHiddenRowScrollTop();
      this._clip.style.maxHeight = '';
      this._wrapper.classList.add('nooma-gallery--expanded');
      this._expanded = true;
      this._setLabel(this.dataset.labelLess);

      if (scrollTop != null) {
        window.scrollTo({ top: scrollTop, behavior: 'smooth' });
      }
    }

    _collapse() {
      const galleryTop = this._wrapper.getBoundingClientRect().top + window.scrollY;
      this._wrapper.classList.remove('nooma-gallery--expanded');
      this._expanded = false;
      this._setLabel(this.dataset.labelMore);
      const h = this._calcPreviewHeight();
      if (h !== null) this._clip.style.maxHeight = h + 'px';
      window.scrollTo({ top: galleryTop, behavior: 'smooth' });
    }

    // Document Y of the first grid row that was below the preview clip (newly revealed on expand).
    _firstHiddenRowScrollTop() {
      const items = Array.from(this._grid.querySelectorAll(':scope > li'));
      if (!items.length) return null;

      const rowMap = new Map();
      for (const li of items) {
        const top = Math.round(li.getBoundingClientRect().top);
        if (!rowMap.has(top)) rowMap.set(top, []);
        rowMap.get(top).push(li);
      }

      const sortedTops = [...rowMap.keys()].sort((a, b) => a - b);
      if (sortedTops.length <= this._previewRows) return null;

      const firstHidden = rowMap.get(sortedTops[this._previewRows])[0];
      return firstHidden.getBoundingClientRect().top + window.scrollY;
    }

    _setLabel(text) {
      const btn = this._btn;
      if (!btn || text == null) return;

      const labelNodes = btn.querySelectorAll('[data-button-label]');
      if (labelNodes.length) {
        for (const node of labelNodes) {
          node.textContent = text;
        }
        return;
      }

      btn.textContent = text;
    }

    disconnectedCallback() {
      this._ro?.disconnect();
    }
  }

  if (!customElements.get('nooma-show-more')) {
    customElements.define('nooma-show-more', NoomaShowMore);
  }
  } catch(e) { console.error(e); }
})();

})();
